/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './ConsentModal.scss';

import { func } from 'prop-types';
import React from 'react';

import ActionButton from 'components/shared/Buttons/ActionButton';
import Disclosure from 'components/shared/Disclosure/Disclosure';
import BaseModal from 'components/shared/Modal/BaseModal';
import Content from 'services/Content';
import SaveLoadingButtonWithPermissions from 'components/shared/LoadingButton/SaveLoadingButtonWithPermissions';

const ConsentModal = ({ onCancel, onSave }) => (
  <BaseModal
    containerClassName="consent-modal"
    disableClickOff={true}
    hideAnchor={true}
    hideClose={true}
    title="Paperless Terms, Conditions and Eligibility Electronic Consent Form"
    isOpen={true}>
    <Disclosure content={Content.emailDeliveryConsentCopy} />
    <div className="consent-modal-buttons">
      <ActionButton
        id="cancel-mail-change"
        type="secondary"
        onClick={onCancel}
        className="consent-modal-buttons-cancel">
        Cancel
      </ActionButton>
      <SaveLoadingButtonWithPermissions
        className="primary-button"
        id="submit-mail-change"
        onClick={onSave}
        requestStatusKey="updateDocumentDelivery"
        shouldDisable>
        Submit
      </SaveLoadingButtonWithPermissions>
    </div>
  </BaseModal>
);

ConsentModal.propTypes = {
  onCancel: func.isRequired,
  onSave: func.isRequired
};

export default ConsentModal;
